import React from "react";
const ComingSoon = () => {
  return (
    <section className="relative min-h-screen overflow-hidden bg-[radial-gradient(1200px_600px_at_10%_-10%,rgba(255,196,122,0.35),transparent_60%),radial-gradient(900px_520px_at_90%_10%,rgba(62,103,255,0.25),transparent_55%),linear-gradient(135deg,#fdf9f4_0%,#f5f1eb_50%,#eef1fb_100%)] px-[7vw] pb-[12vh] pt-[10vh] text-[#0b0b0b] lg:flex lg:items-center">
      <div
        className="pointer-events-none absolute -right-[6vw] top-[8vh] h-[320px] w-[320px] rounded-full bg-[rgba(255,160,72,0.25)] blur-[2px]"
        aria-hidden="true"
      />
      <div
        className="pointer-events-none absolute bottom-[6vh] left-[6vw] h-[240px] w-[240px] rounded-full bg-[rgba(62,103,255,0.22)] blur-[2px]"
        aria-hidden="true"
      />
      <div className="relative z-10 grid items-center gap-[6vw] lg:grid-cols-2">
        <div>
          <span className="inline-flex items-center gap-2 rounded-full bg-black/10 px-4 py-2 font-['Source-Variable'] text-[0.95rem] uppercase tracking-[0.2em]">
            West Coast Wholesale
          </span>
          <h1 className="mt-[2.4vh] font-['Fraunces-Bold'] text-5xl leading-[1.05]">
            A smarter wholesale marketplace is coming soon.
          </h1>
          <p className="mt-[2vh] max-w-[560px] font-['Source-Variable'] text-[clamp(1.1rem,0.4vw+1rem,1.5rem)] leading-[1.7] text-black/75">
            We are building a refined buying experience with curated brands,
            flexible ordering, and transparent pricing. Be first to experience a
            smarter way to stock your shelves.
          </p>
          <div className="mt-[4vh] flex flex-wrap items-center gap-4">
            <span className="font-['Source-Variable'] text-sm uppercase tracking-[0.2em] text-black/60">
              Launching soon
            </span>
          </div>
        </div>

        <div className="lg:justify-self-end">
          <div className="rounded-[24px] bg-white/80 p-10 shadow-[0_24px_50px_rgba(14,25,52,0.08)] backdrop-blur-[12px]">
            <span className="mb-6 inline-block font-['Source-Variable'] text-sm uppercase tracking-[0.18em] text-black/65">
              What to expect
            </span>
            <ul className="flex flex-col gap-4 font-['Source-Variable'] text-[1.05rem] leading-[1.6]">
              <li className="relative pl-7">
                <span className="absolute left-0 top-[0.55rem] h-[0.7rem] w-[0.7rem] rounded-full bg-[linear-gradient(135deg,#ff9f48,#4a63ff)]" />
                Tiered wholesale pricing with transparent margins
              </li>
              <li className="relative pl-7">
                <span className="absolute left-0 top-[0.55rem] h-[0.7rem] w-[0.7rem] rounded-full bg-[linear-gradient(135deg,#ff9f48,#4a63ff)]" />
                Fast restock alerts and low minimum order quantities
              </li>
              <li className="relative pl-7">
                <span className="absolute left-0 top-[0.55rem] h-[0.7rem] w-[0.7rem] rounded-full bg-[linear-gradient(135deg,#ff9f48,#4a63ff)]" />
                Dedicated account support from our West Coast team
              </li>
            </ul>
          </div>
          <div className="mt-10 grid gap-6 sm:grid-cols-3">
            <div className="rounded-[18px] bg-black/5 p-6">
              <p className="font-['Fraunces-Black'] text-3xl">300+</p>
              <p className="mt-1 font-['Source-Variable'] text-sm text-black/65">
                Brands onboarding
              </p>
            </div>
            <div className="rounded-[18px] bg-black/5 p-6">
              <p className="font-['Fraunces-Black'] text-3xl">48 hrs</p>
              <p className="mt-1 font-['Source-Variable'] text-sm text-black/65">
                Target fulfillment window
              </p>
            </div>
            <div className="rounded-[18px] bg-black/5 p-6">
              <p className="font-['Fraunces-Black'] text-3xl">2x</p>
              <p className="mt-1 font-['Source-Variable'] text-sm text-black/65">
                Faster reordering
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ComingSoon;
